/**
 * Chips that fill the composer. They are not sent on their own.
 */
import { el } from '../../core/dom.js';
import { resolvedOf } from './shape.js';

/**
 * @param {object} block
 * @param {{ onAsk?: Function }} [actions]
 * @returns {HTMLElement}
 */
export function renderFollowups(block, actions) {
  const data = resolvedOf(block);
  const items = Array.isArray(data.items) ? data.items.slice(0, 3) : [];
  return el('div', {
    class: 'chat-block chat-followups',
    role: 'group',
    'data-block-type': 'followups',
    'data-block-id': (block && block.id) || '',
    'aria-label': 'Follow-up questions',
  }, items.map((item) => {
    const text = String(item == null ? '' : item).slice(0, 90);
    return el('button', {
      type: 'button',
      class: 'chat-chip',
      onClick: () => {
        if (actions && typeof actions.onAsk === 'function') actions.onAsk(text);
      },
    }, text);
  }));
}
